document.addEventListener('DOMContentLoaded', () => {
    
    const el = document.querySelector('.c-herovideo');
    if (el) {
        const iframe = el.querySelector('iframe'),
              player = new Vimeo.Player(iframe),
              sound = el.querySelector('.js-sound');

        player.on('play', function() {
            iframe.classList.add('is-visible')
            document.querySelector('.c-hero').querySelector('.loader').style.display = 'none';
        });
        
        sound.addEventListener('click', (e) => {                    
            sound.classList.toggle('on');
            sound.classList.contains('on') ? player.setVolume(1) : player.setVolume(0);
        })
    }
    
}, false);